import { render, staticRenderFns } from "./AlertMessage.vue?vue&type=template&id=4a392544&scoped=true&"
import script from "./AlertMessage.vue?vue&type=script&lang=ts&"
export * from "./AlertMessage.vue?vue&type=script&lang=ts&"
import style0 from "./AlertMessage.vue?vue&type=style&index=0&id=4a392544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a392544",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a392544')) {
      api.createRecord('4a392544', component.options)
    } else {
      api.reload('4a392544', component.options)
    }
    module.hot.accept("./AlertMessage.vue?vue&type=template&id=4a392544&scoped=true&", function () {
      api.rerender('4a392544', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/components/ob1/AlertMessage.vue"
export default component.exports